import { render } from "./WizardSteps.vue?vue&type=template&id=78ad9f12"
import script from "./WizardSteps.vue?vue&type=script&lang=ts"
export * from "./WizardSteps.vue?vue&type=script&lang=ts"
script.render = render

export default script